import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dc33f1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-contents" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lead-message" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, "資料の送信方法")
  ])
], -1))
const _hoisted_3 = { class: "action" }
const _hoisted_4 = { class: "send-one" }
const _hoisted_5 = { class: "button-content" }
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "message" }, " 一件ずつ送信 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "新しい資料を一件ずつ送信します。", -1))
const _hoisted_9 = { class: "send-bulk" }
const _hoisted_10 = { class: "button-content" }
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "message" }, " 一括送信 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "複数の資料のファイルとメタデータを圧縮し、一括して送信します。", -1))
const _hoisted_14 = { class: "reuse-metadata" }
const _hoisted_15 = { class: "button-content" }
const _hoisted_16 = { class: "icon" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "message" }, [
  /*#__PURE__*/_createTextVNode(" メタデータを"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 再利用 ")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "送信した資料のメタデータを再利用して、新しい資料を送信します。", -1))
const _hoisted_19 = { class: "navigation-button" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 戻る ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_AppButton, {
            styled: 'is-accent',
            class: "selelct",
            onClick: _ctx.toContentsInput,
            onKeydown: _withKeys(_withModifiers(_ctx.toContentsInput, ["prevent"]), ["space","enter"]),
            buttonId: 'button-contentsInput'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_DssIcon, { icon: 'envelope-fill' })
                ]),
                _hoisted_7
              ])
            ]),
            _: 1
          }, 8, ["onClick", "onKeydown"]),
          _hoisted_8
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createVNode(_component_AppButton, {
            styled: 'is-accent',
            class: "selelct",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('fileInput'))),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('fileInput')), ["prevent"]), ["space","enter"])),
            buttonId: 'button-fileInput'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_DssIcon, { icon: 'envelope-fill' })
                ]),
                _hoisted_12
              ])
            ]),
            _: 1
          }),
          _hoisted_13
        ]),
        _createElementVNode("li", _hoisted_14, [
          _createVNode(_component_AppButton, {
            styled: 'is-accent',
            class: "selelct",
            disabled: _ctx.disabledFlag,
            onClick: _ctx.toSelect,
            onKeydown: _withKeys(_withModifiers(_ctx.toSelect, ["prevent"]), ["space","enter"]),
            buttonId: 'button-select'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_DssIcon, { icon: 'document-book' })
                ]),
                _hoisted_17
              ])
            ]),
            _: 1
          }, 8, ["disabled", "onClick", "onKeydown"]),
          _hoisted_18
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_AppButton, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/dms/outer'))),
        onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('/dms/outer')), ["prevent"]), ["space","enter"])),
        class: "back",
        buttonId: 'button-back'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DssIcon, {
            icon: "arrow-left",
            style: {"font-size":"18px"}
          }),
          _hoisted_20
        ]),
        _: 1
      })
    ])
  ], 64))
}